// src/app/inicio-mobile/inicio-mobile.component.ts
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { InicioComponent } from '../inicio.component';
import { MatDialog } from '@angular/material/dialog';
import { ProductDetailDialogComponent } from './product-detail-dialog/product-detail-dialog.component';
import { ProductosService } from '../../services/productos.service';
import { VentasService } from '../../services/ventas.service';
import { AuthService } from '../../services/auth.service';
import { PagosService } from '../../services/pagos.service';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-inicio-mobile',
  templateUrl: './inicio-mobile.component.html',
  styleUrls: ['./inicio-mobile.component.scss']
})
export class InicioMobileComponent extends InicioComponent {
  currentView: 'search' | 'cart' | 'payment' = 'search';
  searchTerm: string = '';
  mostrarDescuentoPorProducto: { [key: string]: boolean } = {};
  


  constructor(
    fb: FormBuilder,
    productosService: ProductosService,
    ventasService: VentasService,
    toastr: ToastrService,
    cdRef: ChangeDetectorRef,
    authService: AuthService,
    pagosService: PagosService,
    protected dialog: MatDialog
  ) {
    super(fb, productosService, ventasService, toastr, cdRef, authService, pagosService);
  }

  toggleView(view: 'search' | 'cart' | 'payment'): void {
    this.currentView = view;
  }

  // Método para manejar búsqueda en móvil
  onSearch(): void {
    const termino = this.searchTerm;
    if (termino && termino.length >= 2) {
      this.buscando = true;
      this.mostrarSugerencias = true;

      this.productosService.buscarProductos(termino).subscribe({
        next: (productos) => {
          this.productosEncontrados = productos;
          this.buscando = false;
        },
        error: () => {
          this.toastr.error('Error al buscar productos');
          this.buscando = false;
        }
      });
    } else {
      this.mostrarSugerencias = false;
      this.productosEncontrados = [];
    }
  }

  // Sobrescribir métodos para mejor UX móvil
  override agregarProductoDirecto(producto: any): void {
    super.agregarProductoDirecto(producto);
    this.searchTerm = '';
    this.mostrarSugerencias = false;
    this.currentView = 'search';
  }

  protected override resetearVenta(): void {
    super.resetearVenta();
    this.currentView = 'search';
    this.mostrarDescuentoPorProducto = {};
  }

  verDetallesProducto(producto: any): void {
    this.dialog.open(ProductDetailDialogComponent, {
      width: '90vw',
      maxWidth: '420px',
      data: producto,
      autoFocus: false
    });
  }

  toggleDescuento(producto: any): void {
    const productId = producto.id;
    this.mostrarDescuentoPorProducto[productId] = !this.mostrarDescuentoPorProducto[productId];
    
    // Si se oculta el descuento y no hay descuento, no hacer nada
    // Si se oculta y hay descuento, mantener el descuento pero ocultar el campo
    // Si se muestra, el campo aparecerá con el valor actual o 0
  }

  mostrarDescuento(producto: any): boolean {
    return this.mostrarDescuentoPorProducto[producto.id] || false;
  }

  // Sobrescribir generarTicket para incluir lógica de PDF e impresión
  override generarTicket(): void {
    // Usamos la implementación de la clase padre (InicioComponent) que ya contiene
    // la lógica híbrida para web y móvil
    super.generarTicket();
  }

  // Los métodos generarYCompartirPdf y generarYCompartirTicketImpresora
  // ya no son necesarios aquí porque están implementados en la clase padre
  // y soportan ambas plataformas (web y móvil)
}
